import { counterTypes } from '../../utils/TimestampManager';
export default function timerGenerateRender(inNavBar, isTimeInDanger, counterType) {
  var ComponentsName = {
    MISSION_CARD_TIMER_DANGER: 'MISSION_CARD_TIMER_DANGER',
    MISSION_CARD_TIMER: 'MISSION_CARD_TIMER',
    DEFAULT: 'DEFAULT'
  };

  if (!inNavBar && isTimeInDanger && (counterType === counterTypes.MISSION_CARD || counterType === counterTypes.MISSION_GRAND_CARD)) {
    return ComponentsName['MISSION_CARD_TIMER_DANGER'];
  }

  if (!inNavBar && !isTimeInDanger && (counterType === counterTypes.MISSION_CARD || counterType === counterTypes.MISSION_GRAND_CARD)) {
    return ComponentsName['MISSION_CARD_TIMER'];
  }

  return ComponentsName['DEFAULT'];
}